import { render, staticRenderFns } from "./GsLogin.vue?vue&type=template&id=4cdd0ebd&scoped=true&"
import script from "./GsLogin.vue?vue&type=script&lang=js&"
export * from "./GsLogin.vue?vue&type=script&lang=js&"
import style0 from "./GsLogin.vue?vue&type=style&index=0&id=4cdd0ebd&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdd0ebd",
  null
  
)

export default component.exports